// Разрешённые форматы картинок в админке коллекций/NFT. Совпадает с бэкендовым
// NFT_IMAGE_MIME_LIST (png/jpeg/webp) — AVIF и SVG не поддерживаются.
export var ADMIN_IMAGE_ACCEPT = "image/png,image/jpeg,image/webp";
export var ADMIN_IMAGE_MIMES = ["image/png", "image/jpeg", "image/webp"];
export var ADMIN_IMAGE_ERROR = "Только PNG, JPG или WebP (AVIF и SVG не поддерживаются)";
export var isAllowedAdminImage = function (file) {
    return ADMIN_IMAGE_MIMES.includes(file.type);
};
